(() => {
  for (const config of document.querySelectorAll('[data-tt-review-a11y]')) {
    const locale = config.dataset.locale;
    const scope = config.closest('.tt-product-reviews');
    if (!scope || config.dataset.a11yReady || locale !== document.documentElement.lang ||
      !['ja', 'es', 'pt-BR'].includes(locale)) continue;
    config.dataset.a11yReady = 'loaded';
    const rules = [
      ['.jdgm-rev-widg__summary-stars, .jdgm-rev-widg__summary-stars-img', /^Average rating is (\d+(?:[.,]\d+)?) stars?$/, 'average', ['RATING']],
      ['.jdgm-histogram__star', /^(\d+(?:[.,]\d+)?)% \((\d+)\) reviews with ([1-5]) star rating$/, 'distribution', ['PERCENT', 'COUNT', 'RATING']],
      ['.jdgm-paginate__page', /^Page (\d+)$/, 'page', ['PAGE']],
      ['.jdgm-rev__rating', /^([1-5]) star review$/, 'reviewRating', ['RATING']],
      ['.jdgm-form [aria-label]', /^([1-5]) stars?$/, 'star', ['RATING']],
      ['.jdgm-form [aria-label]', /^Choose a review picture\/video \(optional\)$/, 'upload', []],
      ['.jdgm-form [aria-label]', /^Name format$/, 'nameFormat', []]
    ];
    let scheduled = false;
    const reconcile = () => {
      scheduled = false;
      for (const widget of scope.querySelectorAll('.jdgm-review-widget')) {
        for (const [selector, pattern, key, names] of rules) {
          for (const element of widget.querySelectorAll(selector)) {
            const source = element.getAttribute('aria-label');
            const match = source?.match(pattern);
            let value = config.dataset[key];
            if (!match || !value) continue;
            names.forEach((name, index) => { value = value.replaceAll(`__TT_${name}__`, match[index + 1]); });
            if (value !== source) element.setAttribute('aria-label', value);
          }
        }
        for (const form of widget.querySelectorAll('.jdgm-form')) {
          const walker = document.createTreeWalker(form, NodeFilter.SHOW_TEXT);
          while (walker.nextNode()) {
            const node = walker.currentNode;
            if (node.parentElement?.closest('textarea, [contenteditable], script, style')) continue;
            const source = node.nodeValue.trim();
            const value = source === 'Name format' ? config.dataset.nameFormat :
              source === 'Choose a review picture/video (optional)' ? config.dataset.upload : null;
            if (value) node.nodeValue = node.nodeValue.replace(source, value);
          }
        }
      }
    };
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(reconcile);
    }).observe(scope, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
    reconcile();
  }

  const fields = {
    title: '.jdgm-rev__title',
    body: '.jdgm-rev__body',
    reply: '.jdgm-rev__reply-content'
  };
  const hiddenClass = 'tt-review-source-hidden';

  for (const config of document.querySelectorAll('[data-tt-review-translations]')) {
    if (config.dataset.ready || config.dataset.locale !== document.documentElement.lang) continue;
    const scope = config.closest('.tt-product-reviews');
    if (!scope) continue;
    config.dataset.ready = 'loading';

    fetch(config.dataset.url, { credentials: 'omit' })
      .then(response => {
        if (!response.ok) throw new Error('Review translations unavailable');
        return response.json();
      })
      .then(data => {
        if (data.locale !== config.dataset.locale || data.handle !== config.dataset.handle || !Array.isArray(data.records)) {
          throw new Error('Review translation scope mismatch');
        }
        const records = new Map(data.records.map(record => [record.id, record]));
        const states = new Map();
        const originalPreference = new Set();
        let scheduled = false;

        const read = review => Object.fromEntries(Object.entries(fields).map(([field, selector]) => {
          const element = review.querySelector(selector);
          return [field, { element, value: element?.textContent || '' }];
        }));
        const matches = (review, record, current) => record &&
          review.dataset.productUrl === `/products/${data.handle}` &&
          Object.keys(fields).every(field => typeof record.source[field] === 'string' &&
            typeof record.translation[field] === 'string' && current[field].value === record.source[field]);
        const remove = state => {
          state.parts.forEach(part => {
            part.source.classList.remove(hiddenClass);
            part.output.remove();
          });
          state.controls.remove();
          states.delete(state.review);
        };
        const show = (state, translated) => {
          state.parts.forEach(part => {
            part.source.classList.toggle(hiddenClass, translated);
            part.output.hidden = !translated;
          });
          state.badge.hidden = !translated;
          state.button.textContent = translated ? config.dataset.showOriginal : config.dataset.showTranslation;
          state.controls.dataset.showing = translated ? 'translation' : 'original';
        };
        const reconcile = () => {
          scheduled = false;
          for (const state of states.values()) {
            if (!scope.contains(state.review)) remove(state);
          }
          for (const review of scope.querySelectorAll('.jdgm-rev')) {
            const id = review.dataset.reviewId;
            const record = records.get(id);
            const current = read(review);
            const valid = matches(review, record, current);
            const previous = states.get(review);
            if (previous) {
              const intact = valid && previous.id === id && previous.controls.isConnected &&
                Object.keys(fields).every(field => previous.current[field].element === current[field].element) &&
                previous.parts.every(part => part.output.isConnected);
              if (intact) continue;
              remove(previous);
            }
            if (!valid) continue;
            const changed = Object.keys(fields).filter(field => current[field].element &&
              record.translation[field] !== record.source[field]);
            if (!changed.length) continue;
            const parts = changed.map(field => {
              const output = document.createElement('div');
              output.className = `tt-review-translated tt-review-translated--${field}`;
              output.id = `tt-review-${id}-${field}`;
              output.lang = data.locale;
              output.textContent = record.translation[field];
              current[field].element.after(output);
              return { source: current[field].element, output };
            });
            const controls = document.createElement('div');
            controls.className = 'tt-review-translation-controls';
            const badge = document.createElement('span');
            badge.className = 'tt-review-translation-label';
            badge.textContent = config.dataset.translated;
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'tt-review-translation-toggle';
            button.setAttribute('aria-controls', parts.map(part => part.output.id).join(' '));
            controls.append(badge, button);
            const anchor = current.reply.element?.closest('.jdgm-rev__reply') ||
              current.body.element || current.title.element;
            if (!anchor) {
              parts.forEach(part => part.output.remove());
              continue;
            }
            anchor.after(controls);
            const state = { id, review, current, parts, controls, badge, button };
            states.set(review, state);
            button.addEventListener('click', () => {
              if (review.dataset.reviewId !== id || !matches(review, record, read(review))) {
                remove(state);
                return;
              }
              const wasOriginal = originalPreference.has(id);
              if (wasOriginal) originalPreference.delete(id);
              else originalPreference.add(id);
              show(state, wasOriginal);
            });
            show(state, !originalPreference.has(id));
          }
        };
        const observer = new MutationObserver(() => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(reconcile);
        });
        observer.observe(scope, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['data-review-id', 'data-product-url']
        });
        reconcile();
        config.dataset.ready = 'loaded';
      })
      .catch(error => {
        config.dataset.ready = 'unavailable';
        console.warn(error.message);
      });
  }
})();
